import axios from 'axios';
import Vue from 'vue';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Cookies from 'js-cookie';
import router from './router'

Vue.use(VueSweetalert2);

// Buat instance Axios
const instance = axios.create({
  
});

// Intercept request
instance.interceptors.request.use(
  config => {
    // Modifikasi request di sini jika diperlukan
    config.headers.Authorization = `Bearer ${Cookies.get('token')}`;
    return config;
  },
  error => {
    // Tangani error request di sini jika perlu
    return Promise.reject(error);
  }
);

// Intercept response
instance.interceptors.response.use(
  response => {
    // Tangani response sukses di sini
    return response;
  },
  error => {
    // Tangani response error di sini
    if (error.response && error.response.status === 403) {
      const incompleteFields = error.response?.data?.incomplete_fields || {};
      let fieldListHtml = '<div style="text-align: left;">';

      for (const [section, fields] of Object.entries(incompleteFields)) {
        fieldListHtml += `<strong>${section}</strong><ul>`;
        fields.forEach(field => {
          fieldListHtml += `<li>${field}</li>`;
        });
        fieldListHtml += '</ul>';
      }

      fieldListHtml += '</div>';
      
      Vue.swal.fire({
        title: 'Failed',
        html: `Data profile anda tidak lengkap. Silakan lengkapi data berikut: ${fieldListHtml}`,
        icon: 'warning',
        width: '600px',
        // padding: '3em',
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonText: 'OK'
      }).then(() => {
        router.push('/profile');
      });
    }
    return Promise.reject(error);
  }
);

export default instance;